/**
 * RushOrderTees Header Interactivity
 */

document.addEventListener('DOMContentLoaded', () => {
  // Handle Live Chat button
  const liveChatBtns = document.querySelectorAll('[data-rush-live-chat]');
  liveChatBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      // Check if Shopify Inbox or other chat widget is installed
      if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
        window.ShopifyChat.open();
      } else if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
        window.Tawk_API.maximize();
      } else if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
        window.tidioChatApi.open();
      } else {
        // Fallback: prompt user or scroll to contact
        alert("Our team is available 24/7! You can also call us directly at (919) 909-0978.");
      }
    });
  });

  // Mobile search focus animation
  const mobileSearchInput = document.querySelector('.rush-mobile-search-row input[type="search"]');
  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('focus', () => {
      mobileSearchInput.closest('.rush-search-box')?.classList.add('is-focused');
    });
    mobileSearchInput.addEventListener('blur', () => {
      mobileSearchInput.closest('.rush-search-box')?.classList.remove('is-focused');
    });
  }
});
